import React from "react";

const SHOW_LOGGER = true && process.env.NODE_ENV === 'development';

const DevLogger = ({ data }) => {
  return (
    <>
      {SHOW_LOGGER ? (
        <pre className="w-full p-4 mb-8 border overflow-auto">
          {JSON.stringify(data, "", 2)}
        </pre>
      ) : (
        <></>
      )}
    </>
  );
};

export default DevLogger;
